import {Component} from '@angular/core';

@Component({
  selector: 'micro-mail-message-log-incoming',
  templateUrl: './mail-message-log-incoming.component.html'
})
export class MailMessageLogIncomingComponent {

}
